export const audience = [
    {
        title: "Want to earn money?",
        desciption: "Start creating social content today and turn every post into steady income.",
        image: "/images/bloggers-landing/png/section-6-1.png",
        id: "audience-1"
    },
    {
        title: "Beginning blogger",
        desciption: "New blogger, accelerate growth and attract fans with proven tactics.",
        image: "/images/bloggers-landing/png/section-6-2.png",
        id: "audience-2"
    },
    {
        title: "Experienced blogger",
        desciption: "Simplify workflow, gain fresh skills, and elevate pieces you publish.",
        image: "/images/bloggers-landing/png/section-6-3.png",
        id: "audience-3"
    },
    {
        title: "Freelancer",
        desciption: "Craft client content faster using automation that multiplies output and boosts revenue.",
        image: "/images/bloggers-landing/png/section-6-4.png",
        id: "audience-4"
    },
    {
        title: "Entrepreneur",
        desciption: "Need clients via social yet lack hours for steady posts? We simplify.",
        image: "/images/bloggers-landing/png/section-6-5.png",
        id: "audience-5"
    },
    {
        title: "AI newbie",
        desciption: "Fear missing AI trends and want cutting-edge creator tech? Stay ahead here.",
        image: "/images/bloggers-landing/png/section-6-6.png",
        id: "audience-6"
    }
];

export const feedbacks = [
    {
        authorName: "Andi",
        authorTag: "@adventurerr99",
        comment: "I gained +1000 subscribers in just the first two videos, and this is just the beginning!",
        image: "/images/bloggers-landing/png/section-3-1.png"
    },
    {
        authorName: "Wanda",
        authorTag: "@fashion1queen",
        comment: "I created a week's worth of content in just 30 minutes online. Now my avatar talks without me.",
        image: "/images/bloggers-landing/png/section-3-2.png"
    },
    {
        authorName: "Carlos",
        authorTag: "@carlohiker1990",
        comment: "I learned a lot during the challenge. I'm just starting, but I already know what I'm going to do.",
        image: "/images/bloggers-landing/png/section-3-3.png"
    }
];

export const creatorSubscriptionsIds = [
    "1c234bef-8fb2-4db9-a5fd-c89dd3fdbc0e",
    "847e4727-58e5-48a0-a8a2-6e8e0edf2383",
    "7987d4ee-2c87-45d2-bafa-5cd451824bec"
];
